import { Layouts } from "./Layouts.js";

function Structure(parameters = { children: null, shuffle: false, middleElementsNames: [], EventHeader: false }) {
    const { children, shuffle, middleElementsNames, EventHeader } = parameters || {};

    // By Custom children
    if (Array.isArray(children) && children.length === 0) {
        throw new Error("ERROR!!!!");
    } else if (Array.isArray(children) && children.length > 0) {
        // return { ...Layouts.Project(children), structureVirgin: children };
        return Layouts.Project(children);
    }

    // By Templates
    const HeaderElement = EventHeader ? Layouts.EventHeader() : Layouts.Header();

    const middleElements =
        middleElementsNames?.length > 0
            ? middleElementsNames.map(name => Layouts[name]())
            : [
                  Layouts.Features(),
                  Layouts.Slider(),
                  Layouts.Steps(),
                  Layouts.Numbers(),
                  Layouts.Embed(),
                  Layouts.Video(),
                  Layouts.Offers(),
                  Layouts.Feedbacks(),
              ];

    const outerElements = [];
    EventHeader && outerElements.push(Layouts.Timer());

    return Layouts.Project([
        Layouts.Menu(),
        HeaderElement,
        ...(shuffle ? [{ shuffle: middleElements }] : middleElements),
        Layouts.GetInTouch(),
        Layouts.Footer(),
        Layouts.CookiesPopup(),
        ...outerElements,
    ]);
}

function StructureECommerce(parameters = { children: null }) {
    const { children, shuffle } = parameters || {};

    if (children && children.length > 0) {
        return Layouts.Project(children);
    }

    return Layouts.Project(
        [
            Layouts.Menu(),
            Layouts.HeaderEcommerce(),
            Layouts.Features(),
            Layouts.ProductDescription(),
            Layouts.Numbers(),
            Layouts.Feedbacks(),
            Layouts.BlockECommerce(),
            Layouts.GetInTouch(),
            Layouts.Delivery(),
            Layouts.Footer(),
            Layouts.CookiesPopup(),
        ].filter(v => v)
    );
}

export default Structure;
export { StructureECommerce };
